import { DiagnosisVo2 } from '@app/core/services/api-client.service';

// Primary first (stable: the rest keep their relative order) with PrimaryIndicator aligned to it:
// PMA reads position 0, while Florence's claim hand-off sorts by the flag.
export function applyPrimaryDiagnosis(diagnoses: DiagnosisVo2[] | null | undefined, primaryCode?: string | null): DiagnosisVo2[] {
  const list = diagnoses || [];
  const code = primaryCode ?? list[0]?.DiagnosisCode;
  const index = list.findIndex(d => d?.DiagnosisCode === code);
  const ordered = index > 0 ? [list[index], ...list.slice(0, index), ...list.slice(index + 1)] : list;
  return ordered.map(d => ({ ...d, PrimaryIndicator: !!code && d?.DiagnosisCode === code }));
}
